import parse from "html-react-parser";
import { useParams } from "react-router-dom";
import { useWindowSize } from "react-use";

import { useLayout } from "../../lib/hooks/useQueryBoard";

import BackButton from "../../components/BackButton";

import { WayfindingGrid } from "../Wayfinding";

import { useHeaderHeightContext } from "../../context/HeaderHeight";

import "react-quill/dist/quill.snow.css";

const WayfindingOptionPage = () => {
  const { option } = useParams<{ option: string }>();

  const { multiWayfinding } = useLayout();

  const { height: headerHeight } = useHeaderHeightContext();
  const { width, height } = useWindowSize();

  if (!option) return null;

  const optionIndex = Number(option);

  if (Number.isNaN(optionIndex)) return null;

  return (
    <div className="d-flex align-items-center flex-column">
      <BackButton to="/wayfinding" />
      <WayfindingGrid
        container
        justifyContent="center"
        columnGap={4}
        headerHeight={width < height ? headerHeight : 0}
        footerHeight={width < height ? 440 : 310}
        style={{
          width: "100%",
          padding: "0 14rem",
          marginTop: "0",
        }}
      >
        <div className="ql-snow" style={{ width: "100%" }}>
          <div className="ql-editor">
            {parse(
              multiWayfinding?.wayfindingOptions?.[optionIndex]
                ?.instructionLabel || "",
            )}
          </div>
        </div>
      </WayfindingGrid>
    </div>
  );
};

export default WayfindingOptionPage;
